// document.querySelector('html').classList.add('js-search-loaded');
// const input = document.querySelector('.jss-input');

let searchTimeout;
let currentQuery;

document.querySelector('.jss-input').addEventListener('input', function() {
    clearTimeout(searchTimeout); // Clear any existing timeout

    searchTimeout = setTimeout(() => {
        let query = this.value.trim();
        if (query.length > 0) {
            loadSearchSection(query);
        }
    }, 300); // Delay of 1 second
});

function loadSearchSection(query) {

    let stype;
    const searchContainer = document.querySelector('.js-search');
    if (searchContainer.getAttribute('data-search-type') === 'article') {
        stype = 'article';
    } else {
        stype = 'product';
    }
    currentquery = query;


    fetch(`/search/suggest?q=${encodeURIComponent(query)}&section_id=zpro-search&resources[limit_scope]=each&resources[type]=`+stype+`,query`)
    // fetch(`/search/suggest?q=${encodeURIComponent(query)}&section_id=zpro-search&resources[type]=product,query`)
    // fetch(`/search/suggest?q=${encodeURIComponent(query)}&section_id=zpro-search`)
        .then(response => response.text())
        .then(data => {
            document.querySelector('.jss-results').innerHTML = data;
        })
        .catch(error => console.error('Error loading search section:', error));
}
// https://us.jshealthvitamins.com/search/suggest?q=hairs&resources%5Blimit_scope%5D=each&section_id=predictive-search


document.addEventListener('click', function(e) {
    const swapEl = e.target.closest('[data-swap-search]');
    if (swapEl) {
        const searchType = swapEl.getAttribute('data-swap-search');
        const searchContainer = document.querySelector('.js-search');
        if (searchContainer) {
            searchContainer.setAttribute('data-search-type', searchType);
        }
        e.preventDefault();
        loadSearchSection(currentquery);
    }
});

function closeMegaMenu() {
    document.querySelectorAll('[name="menu-radio-top-level"]').forEach(function(radio) {
        radio.checked = false;
    });
    document.querySelectorAll('.header__nav-link.active').forEach(function(link) {
        link.classList.remove('active');
    });
    var activeEl = document.activeElement;
    if (activeEl && activeEl.closest('.header__navigation')) {
        activeEl.blur();
    }
}

function isSearchOpen() {
    return document.documentElement.classList.contains('js-search-loaded');
}

function closeSearch() {
    setSearchOpen(false);

    const searchInput = document.querySelector('.jss-input');
    if (searchInput) {
        searchInput.value = '';
    }
}

function setSearchOpen(isOpen) {
    document.documentElement.classList.toggle('js-search-loaded', isOpen);
    document.body.classList.toggle('js-search-loaded', isOpen);
}

document.addEventListener('mousedown', function(e) {
    if (e.target.closest('.openSearch')) {
        closeMegaMenu();
        return;
    }

    const navTrigger = e.target.closest('.header__nav-link label, .header__nav-link > a');
    if (navTrigger && isSearchOpen()) {
        closeSearch();
    }
});

// Combined open and close search functionality
document.addEventListener('click', function(e) {
    const closeSearchBtn = e.target.closest('.close-search');
    const openSearchBtn = e.target.closest('.openSearch');
    const jsSearchElement = e.target.closest('.js-search');

    if (closeSearchBtn) {
        closeSearch();
        e.preventDefault();
    }

    if (openSearchBtn) {
        closeMegaMenu();
        setSearchOpen(true);

        // Focus on the search input
        const searchInput = document.querySelector('.jss-input');
        if (searchInput) {
            searchInput.focus();
        }

        e.preventDefault();
    }

    if (jsSearchElement && !e.target.closest('.jss-input') && !e.target.closest('.jss-results')) {
        setSearchOpen(false);
    }
});

// Close search on ESC key press
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
        closeSearch();
    }
});
